module.exports = __webpack_public_path__ + "img/logo.3a93b833.svg";